
import React, { useEffect, useState } from 'react'
import { useSearchParams } from "react-router-dom"
import DDLCountSection from "./DDLCountSection/DDLCountSection"
import { useAuthState } from '../../../../Helper/Context'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../../../Helper/Loading'
import EducationDashSidebar from './EducationDashboardSidebar/EducationDashSidebar'
import EducationDashMasterCard from './EducationDashMasterCard/EducationDashMasterCard'
import { EducationGardenDailyChecklist } from './EducationGardenDailyChecklist/EducationGardenDailyChecklist'
import { WorkTypeButtonGetAPI } from '../../../../Redux/MainCountSlice/MainWorkTypeButtonSlice'
import { EducationWorkAssignOfficialsContractorPending } from './EducationWorkAssignOfficialsContractorPending/EducationWorkAssignOfficialsContractorPending'

export const EducationDashboard = () => {

    const { t } = useTranslation()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Countdata, setCountdata] = useState({})

    const [WorkTypeBtnData, setWorkTypeBtnData] = useState([])
    const [WorkActiveButton, setWorkActiveButton] = useState(0);
    const [YearValue, setYearValue] = useState(null)
    const [YearLabel, setYearLabel] = useState(null)
    const [MonthValue, setMonthValue] = useState(null)
    const [MonthLabel, setMonthLabel] = useState(null)
    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)
    const [ZoneValue, setZoneValue] = useState(null)
    const [ZoneLabel, setZoneLabel] = useState(null)
    const [Date, setDate] = useState('');

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: ''
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])

    const [ZoneNameDDLID, setZoneNameDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "",
    })

    const [ActiveButton, setActiveButton] = useState('दैनंदिन कामे');

    const handleButtonClick = (index) => {
        setActiveButton(index);
    };

    const [ActiveMasterCard, setActiveMasterCard] = useState('1')

    const handleActiveMasterCardClick = (navigate) => {
        setActiveMasterCard(navigate);
    };

    useEffect(() => {
        const data = {
            M_FinancialYearID: YearValue,
            M_WardID: WardName.ID,
            M_ZoneID: ZoneValue,
            M_MonthID: MonthValue,
            M_UserID: UserID,
            Flag: "WEB",
            token: token,
            handleGetCount: handleGetCount
        }
    
    }, [YearValue, MonthValue, WardName.ID, ZoneValue])

    const { GardenDashCountData, isLoading } = useSelector(state => state.GardenDashMainCountData)

    const handleGetCount = (data) => {

        let tempData = {}
        data.forEach((item) => {
            tempData[item.paramName] = item.totalCount
        })
        setCountdata(tempData)
    }

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            Flag: "DB_Master",
            token: token,
            Language: Language.Label,
            handleWorkButtonData: handleWorkButtonData
        }

        { Language.Label != '' && dispatch(WorkTypeButtonGetAPI({ data })) }

    }, [Language.Label, ActiveButton])

    const { isDDLLoading } = useSelector(state => state.WorkTypeButtonGetData)

    const handleWorkButtonData = (data) => {
        setWorkTypeBtnData && setWorkTypeBtnData(data)
        setWorkActiveButton && setWorkActiveButton(data && data.length > 0 && data[0]?.workTypeID)
    }

    const handleWorkActiveButtonClick = (WorkTypeID) => {
        setWorkActiveButton(WorkTypeID);
    };

    const SchoolData = {
        "table": [
            {
                "workTypeID": 1,
                "workTypeName": "आयटी कामे"
            },
            {
                "workTypeID": 2,
                "workTypeName": "सिव्हिल कामे"
            },
            {
                "workTypeID": 3,
                "workTypeName": "सुरक्षा कामे"
            },
            {
                "workTypeID": 4,
                "workTypeName": "इलेक्ट्रिकल कामे"
            },
            {
                "workTypeID": 5,
                "workTypeName": "शालेय पोषण आहार"
            },
            {
                "workTypeID": 6,
                "workTypeName": "पट तपासणी"
            }
        ]
    }
    return (
        <>
            {(isLoading || isDDLLoading) && <Loading />}
            <div>

                {/* <Sidebar active="dashboard" /> */}
                <div className="wrapper bg-change">
                    <EducationDashSidebar
                        ProjectTypeId={ProjectTypeId}
                        Language={Language}
                        YearValue={YearValue}
                        YearLabel={YearLabel}
                        MonthValue={MonthValue}
                        MonthLabel={MonthLabel}
                        WardValue={WardValue}
                        WardLabel={WardLabel}
                        ZoneValue={ZoneValue}
                        ZoneLabel={ZoneLabel}
                    />
                    {/* ----------------------- DDL_Section ------------------- */}

                    <div className="content1 content mt-3" style={{ height: '100vh' }}>
                        <DDLCountSection
                            Countdata={Countdata}
                            YearValue={YearValue}
                            setYearValue={setYearValue}
                            YearLabel={YearLabel}
                            setYearLabel={setYearLabel}
                            MonthValue={MonthValue}
                            setMonthValue={setMonthValue}
                            MonthLabel={MonthLabel}
                            setMonthLabel={setMonthLabel}
                            setWardValue={setWardValue}
                            setWardLabel={setWardLabel}
                            setZoneValue={setZoneValue}
                            setZoneLabel={setZoneLabel}
                            Language={Language}
                            ZoneNameDDLID={ZoneNameDDLID}
                            setZoneNameDDLID={setZoneNameDDLID}
                            WardName={WardName}
                            setWardName={setWardName}
                            Flag='officer'
                        />
                        {/* --------------------------Master Data Card ---------------- */}

                        <div className="py-2 master_border_master_card  me-lg-2">

                            <EducationDashMasterCard
                                Countdata={Countdata}
                                ProjectTypeId={ProjectTypeId}
                                DashboardName={DashboardName}
                                ActiveMasterCard={ActiveMasterCard}
                                setActiveMasterCard={setActiveMasterCard}
                                handleActiveMasterCardClick={handleActiveMasterCardClick}
                                ActiveButton={ActiveButton}
                                setActiveButton={setActiveButton}
                                handleButtonClick={handleButtonClick}
                            />

                        </div>

                        {/* ----------------------- उद्यान दैनंदिन कामे ------------------ */}

                        <div className=" m-0 pe-2 mb-3">
                            {
                                ((ActiveButton == "दैनंदिन कामे") && (ActiveMasterCard == '1' || ActiveMasterCard == '2')) &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-3">
                                            <p className="pt-1 fw-bold mb-0 text-white" style={{ fontSize: '19px' }}>{t('Educationdashboard.dashboard.Daily_Work')} </p>
                                        </div>
                                        <div className="col-12 col-lg-6">
                                            <div className="btn-group text-center float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid rgb(223, 218, 218)', borderRadius: '5px' }}>
                                                {
                                                    SchoolData && SchoolData.table && SchoolData.table.length > 0 && SchoolData.table.map((i, j) =>
                                                        <>
                                                            <button
                                                                key={i.workTypeID}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                                onClick={() => handleWorkActiveButtonClick(i.workTypeID)}
                                                                className={
                                                                    WorkActiveButton == i?.workTypeID
                                                                        ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2"
                                                                        : "text-white fw-bold btn px-2 d-flex border-right "
                                                                }
                                                            >
                                                                {i.workTypeName}
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-1 float-end ">
                                            <label for="exampleInputEmail1"
                                                className="form-label pt-1 float-end fw-bold text-white fs-6"
                                            >Date:</label>
                                        </div>
                                        <div className="col-12 col-lg-2 pb-1">
                                            <input type="date"
                                                class="form-control "
                                                id="exampleInputEmail1"
                                                aria-describedby="emailHelp"
                                                name="Date"
                                                value={Date}
                                                onChange={(e) => setDate(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {
                                        RoleID == 2 || RoleID == 3 || RoleID == 7 || RoleID == 10 || RoleID == 15 ?
                                            <div className="me-0 ms-0 mt-1 me-1 pb-0 pe-1 master_border ">
                                                <EducationGardenDailyChecklist
                                                    YearValue={YearValue}
                                                    MonthValue={MonthValue}
                                                    WardValue={WardValue}
                                                    ZoneValue={ZoneValue}
                                                    Language={Language}
                                                    AssetType='1'
                                                    Date={Date}
                                                    WorkActiveButton={WorkActiveButton}
                                                    ActiveButton='Daily_Officer'
                                                />
                                            </div>
                                            :
                                            <></>
                                    }
                                </>
                            }
                        
                            {
                                ActiveButton == "प्रशासनाने वाटप केलेली कामे" &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-7 py-1">
                                            <span className="fw-bold" style={{ fontSize: "19px" }}>{t('Dashboard.Titles.Work_Assigned_by_Officials')} -  {t('EmployeeAndContractor.Officer_Name_Pending_Work_Status')}</span>

                                        </div>
                                        <div className="col-12 col-lg-5 pb-1">
                                            <div className="btn-group text-center float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid rgb(223, 218, 218)', borderRadius: '5px' }}>
                                                {
                                                    WorkTypeBtnData && WorkTypeBtnData.length > 0 && WorkTypeBtnData.map((i, j) =>
                                                        <>
                                                            <button
                                                                key={i.workTypeID}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                                onClick={() => handleWorkActiveButtonClick(i.workTypeID)}
                                                                className={
                                                                    WorkActiveButton == i?.workTypeID
                                                                        ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2"
                                                                        : "text-white fw-bold btn px-2 d-flex border-right "
                                                                }
                                                            >
                                                                {i.workTypeName}
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="border rounded mt-0  me-0 my-1 rounded bg-white border-0 sec_sec sec_sec_375 px-2 ps-2 pt-0">
                                        {
                                            RoleID == 2 || RoleID == 3 || RoleID == 15 ?

                                                <div className=" mt-2 m-0 p-0 master_border last_row">
                                                    <EducationWorkAssignOfficialsContractorPending
                                                        ActiveButton='कर्मचारी'
                                                        ZoneValue={ZoneValue}
                                                        WardValue={WardValue}
                                                        Language={Language}
                                                        WorkActiveButton={WorkActiveButton}
                                                    />
                                                </div>
                                                : ''
                                        }

                                    </div>
                                </>
                            }
                            {
                                ActiveButton == "ठेकेदारनिहाय कामाची प्रगती" &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-7 py-1">
                                            <span className="fw-bold" style={{ fontSize: "19px" }}>{t('Dashboard.Titles.Work_Progress_By_Contractor')} - {t('EmployeeAndContractor.Contractor_Name_Pending_Work_Status')}</span>
                                        </div>
                                        <div className="col-12 col-lg-5 pb-1">
                                            <div className="btn-group text-center float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid rgb(223, 218, 218)', borderRadius: '5px' }}>
                                                {
                                                    WorkTypeBtnData && WorkTypeBtnData.length > 0 && WorkTypeBtnData.map((i, j) =>
                                                        <>
                                                            <button
                                                                key={i.workTypeID}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                                onClick={() => handleWorkActiveButtonClick(i.workTypeID)}
                                                                className={
                                                                    WorkActiveButton == i?.workTypeID
                                                                        ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2"
                                                                        : "text-white fw-bold btn px-2 d-flex border-right "
                                                                }
                                                            >
                                                                {i.workTypeName}
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>


                                    <div className="border m-0 my-1 rounded border-0 p-2 sec_sec bg-white">
                                        {
                                            RoleID == 2 || RoleID == 3 || RoleID == 15 ?

                                                <div className=" m-0 p-0 master_border last_row">
                                                    <EducationWorkAssignOfficialsContractorPending
                                                        ActiveButton='ठेकेदार'
                                                        ZoneValue={ZoneValue}
                                                        WardValue={WardValue}
                                                        Language={Language}
                                                        WorkActiveButton={WorkActiveButton}
                                                    />
                                                </div>
                                                : ''
                                        }
                                    </div>

                                </>
                            }
                            {/* Work Progress Card End */}


                            {/* Reopen Work Progress Card Start */}
                            {
                                ActiveButton == "पुन्हा वाटप केलेल्या कामाची प्रगती" &&
                                <>
                                    <div className="row m-0 pt-1 px-2  mt-2 mb-2 bg-green " >
                                        <div className="col-12 col-lg-7 py-1">
                                            <span className="fw-bold" style={{ fontSize: "19px" }}>{t('Dashboard.Titles.Work_Reopen_Progress_By_Contractor')} - {t('EmployeeAndContractor.Contractor_Name_Pending_Work_Status')}</span>

                                        </div>
                                        <div className="col-12 col-lg-5 pb-1">
                                            <div className="btn-group text-center float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid rgb(223, 218, 218)', borderRadius: '5px' }}>
                                                {
                                                    WorkTypeBtnData && WorkTypeBtnData.length > 0 && WorkTypeBtnData.map((i, j) =>
                                                        <>
                                                            <button
                                                                key={i.workTypeID}
                                                                style={{ whiteSpace: 'nowrap' }}
                                                                onClick={() => handleWorkActiveButtonClick(i.workTypeID)}
                                                                className={
                                                                    WorkActiveButton == i?.workTypeID
                                                                        ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2"
                                                                        : "text-white fw-bold btn px-2 d-flex border-right "
                                                                }
                                                            >
                                                                {i.workTypeName}
                                                            </button>
                                                        </>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>


                                    <div className="border m-0 rounded bg-white border-0 p-2 pb-2 sec_sec">
                                        {
                                            RoleID == 2 || RoleID == 3 || RoleID == 15 ?

                                                <div className="m-0 p-0 master_border last_row">
                                                    <EducationWorkAssignOfficialsContractorPending
                                                        ActiveButton='ReopenContractor'
                                                        ZoneValue={ZoneValue}
                                                        WardValue={WardValue}
                                                        Language={Language}
                                                        WorkActiveButton={WorkActiveButton}
                                                    />
                                                </div>
                                                : ''
                                        }
                                    </div>

                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>


        </>

    )
}